<script setup>
import { useStore } from "vuex";
import { computed } from "vue";
import ScrollToElement from "common/utils/ui/scroll-to-element";
import { n } from "components/jiffy/vue-cart/helpers/currency";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";
import { trackCartIconClick } from "../utils/tracker";

const store = useStore();
const props = defineProps({
  inactive: {
    type: Boolean,
    required: false,
    default: false
  }
});

const productTotal = computed(() => store.getters["checkout/totals"]?.createdProduct);
const inactive = computed(() => props.inactive || !productTotal.value);
const count = computed(() => store.getters["product/totalQty"]);

const handleScrollToAnchor = () => {
  ScrollToElement.scrollIntoViewBySelector("#pod-build-order-checkout", 85);
  trackCartIconClick();
};
</script>

<template>
  <button
    class="checkout-total"
    :class="{ 'checkout-total--inactive': inactive }"
    type="button"
    @click.stop="handleScrollToAnchor"
  >
    <UseSvg class="checkout-total__icon" icon="shopping-cart" type="print" />
    <div class="checkout-total__count">{{ count }}</div>
    <div class="checkout-total__total">{{ n(productTotal, "currency") }}</div>
  </button>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/button/mixin.scss";
@import "frontend/init/pod/settings";

.checkout-total {
  $this: &;

  @include clear-button;

  color: $white;
  position: relative;
  display: flex;
  align-items: center;

  &--inactive {
    #{$this}__count {
      background: $pod-gray-modern-500;
    }
  }

  &__icon {
    flex: none;
    align-items: center;
    width: 24px;
    height: 24px;
  }

  &__count {
    position: absolute;
    top: -2px;
    left: 15px;
    font-size: 10px;
    font-weight: 600;
    text-align: center;
    line-height: 16px;
    min-width: 16px;
    height: 16px;
    border-radius: 8px;
    padding: 0 4px;
    background: $medium-slate-blue;
  }

  &__total {
    margin-left: 9px;
    font-size: 15px;
    line-height: 1;
    font-weight: 600;
  }
}
</style>
